<template>
  <v-layout wrap style="font-size:0.7em" class="ie-is-broken-date-range-picker" align-center>
    <v-flex v-if="$vuetify.breakpoint.xs" xs4 pl-10>
      From
    </v-flex>
    <v-flex sm3 xs7 offset-sm-2>
      <v-dialog ref="startDialog"
                v-model="dateStartModal"
                :return-value.sync="start"
                persistent
                width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field :value="format(start)"
                        label="Start date"
                        prepend-icon="event"
                        readonly
                        @click:prepend="on.click()"
                        v-on="on"></v-text-field>
        </template>
        <v-date-picker v-model="start" scrollable :class="{'pb-10':$vuetify.breakpoint.xs}">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dateStartModal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.startDialog.save(start)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>

    <v-flex xs4 sm2 :class="['d-flex justify-center', {'pl-2 mt-n5':$vuetify.breakpoint.xs}]">
      <v-radio-group v-model="endless" :mandatory="true">
        <v-radio label="Onward" value="0"></v-radio>
        <v-radio label="until..." value="1"></v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex xs7 sm3 :class="{'align-self-end': $vuetify.breakpoint.xs}">
      <v-dialog ref="endDialog"
                v-model="dateEndModal"
                :return-value.sync="end"
                persistent
                width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field :value="format(end)"
                        label="End date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        @click:prepend="on.click()"
                        :disabled="!+endless"></v-text-field>
        </template>
        <v-date-picker v-model="end" scrollable :class="{'pb-10':$vuetify.breakpoint.xs}">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dateEndModal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.endDialog.save(end)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment';
  const locale = window.navigator.userLanguage || window.navigator.language;


  export default {

    props: [
      'value'
    ],
    data: () => ({
      now: new Date(),
      dateStartModal: false,
      dateEndModal: false,
      endlessRadio: false,
    }),
    computed: {
      start: {
        get() {
          if (!this.value)
            return null
          if (typeof this.value.start === "string") 
            return this.value.start.substr(0, 10);
          if (this.value.start instanceof Date)
            return this.value.start.toISOString().substr(0, 10);
          return null;
        },
        set(v) { console.log(v); this.$emit('input', { end: this.value.end, start: typeof v === "string" ? new Date(v) : v }); }
      },
      end: {
        get() {
          if (!this.value)
            return null
          if (typeof this.value.end === "string")
            return this.value.end.substr(0, 10);
          if (this.value.end instanceof Date)
            return this.value.end.toISOString().substr(0, 10);
          return null; },
        set(v) { this.$emit('input', { end: typeof v === "string" ? new Date(v) : v, start: this.value.start }); }
      },
      endless: {
        get() { return (this.end || this.endlessRadio) ? "1" : "0" },
        set(v) { if (!+v) this.end = null; this.endlessRadio = !!+v}
      }
    },
    methods: {
      format(time) {
        return time && moment(time).format('L');
      }
    },
    created() {
      moment.locale(locale);
    }
  };
</script>
<style scoped>
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .ie-is-broken-date-range-picker {
      margin-top: 60px;
    }
  }
</style>
